import {requestMs} from "@helpers/api";

export const carchecks = {
  getCarChecks: (params) => requestMs.get(`api3/user/${params.id}/carcheck?${ params.query}`, { page: params.page}),
  getCarCheck: (id) => requestMs.get(`api3/carcheck/${id}`),
};
